import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';

export const ActionCardContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;

  > * + *:not(:empty) {
    margin-top: ${theme.spacings[3].rem};

    ${breakpoint('sm')`
      margin-top: ${theme.spacings[4].rem};
    `};
  }
`;
